import { Box, BoxProps, ColorOptions, LoaderNew, ModBox, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useFocusEffect, useNavigation } from '@react-navigation/core'
import React, { useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import ActionsMenu from '../../components/ActionMenu/ActionsMenu'
import { Filters } from '../../components/FiltersWeb'
import { filterTypes } from '../../components/FiltersWeb/types'
import { ModalAlertView } from '../../components/ModalAlertView'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { filtersData } from '../../utils'
import { checkerHeaderTitles, getCustomColumnWidth } from '../../utils/constants'

const Footer = ({ onClaimPress }: any) => {
  const onSubmit = () => {
    onClaimPress()
  }
  return (
    <Box {...styles.footer}>
      <ButtonNew onPress={onSubmit} title={'+ Claim'} height={40} width={94} color={'PRIMARY'} />
    </Box>
  )
}

const Header = ({ fetchDataOnChange, filterVisible, setFilterVisible, filterApplied }: any) => {
  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <Text title={'Application Queue'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          showSearch={true}
          enableFilter
          showCalendar
          defaultPage={1}
          type="global"
          filterApplied={filterApplied}
        />
      </ModBox>
    </Box>
  )
}
const Checker = () => {
  const {
    fetchGlobalListOfChecker,
    updateSelectedRowIndex,
    getRowsSelected,
    currentPage,
    getGlobalList,
    globalCheckerListLength,
    updateAllRowsSelection,
    checkSelected,
    selectedFilteredData,
    updateFilters,
    selectedDateInfo,
    pagination,
    claimTask,
    userName,
    setSideMenuRefresh,
    saveState,
    resetState,
    restoreFiltersToDefaults,
    setSearchFilterBy,
    resetFeePkgId,
    resetCheckerApplicationStatus,
  } = useStores((store) => ({
    fetchGlobalListOfChecker: store.getGlobalCheckerList,
    updateSelectedRowIndex: store.updateSelectedRowIndex,
    getRowsSelected: store.getRowsSelected,
    currentPage: store.pagination.number,
    getGlobalList: store.getCheckerGlobalList,
    globalCheckerListLength: store.globalCheckerList.length,
    updateAllRowsSelection: store.updateAllRowsSelection,
    checkSelected: store.filter.checkSelected,
    selectedFilteredData: store.filter.getFilterData,
    updateFilters: store.filter.updateFilters,
    selectedDateInfo: store.selectedDateInfo,
    pagination: store.pagination,
    claimTask: store.claimTask,
    userName: store.user.name,
    setSideMenuRefresh: store.setSideMenuRefresh,
    saveState: store.filter.saveState,
    resetState: store.filter.resetState,
    restoreFiltersToDefaults: store.filter.restoreFiltersToDefaults,
    applicationStatusLength: store.filter.applicationStatus.length,
    getSelectedGlobalListLength: store.getSelectedGlobalListLength(),
    setSearchFilterBy: store.onboarding.setSearchFilterBy,
    resetFeePkgId: store.onboarding.resetFeePkgId,
    resetCheckerApplicationStatus: store.resetCheckerApplicationStatus,
  }))

  const navigation = useNavigation()
  const [listData, setListData] = useState<any>([])
  const [isLoading, setLoading] = useState(false)
  const [showClaim, setShowClaim] = useState(false)
  const [showAlertInfo, setShowAlertInfo] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)

  const [lazyGetGlobalCheckerList, globalCheckerListHandler] = useLazyApiData(fetchGlobalListOfChecker)

  const [claimTaskApi, claimTaskHandler] = useLazyApiData(claimTask)

  useEffect(() => {
    if (claimTaskHandler.state === 'fulfilled') {
      setShowAlertInfo(true)
      setLoading(false)
    } else if (claimTaskHandler.state === 'rejected') {
      setLoading(false)
    }
  }, [claimTaskHandler.state, setShowAlertInfo])

  useEffect(() => {
    if (globalCheckerListHandler.state === 'fulfilled' || globalCheckerListHandler.state === 'rejected') {
      const list = getGlobalList()
      setListData(list)
      setLoading(false)
    }
  }, [getGlobalList, globalCheckerListHandler.state, globalCheckerListLength])

  useFocusEffect(
    React.useCallback(() => {
      setLoading(true)
      lazyGetGlobalCheckerList()
      setSideMenuRefresh(true)
      setSearchFilterBy('Entity ID')
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  )

  const onPress = (item: any) => {
    setSearchFilterBy('Entity ID')
    resetFeePkgId()
    resetCheckerApplicationStatus()
    if (item?.applicationStatus === 'Error') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: { data: item, from: 'CHECKER_MYQUEUE', isApprovedByChecker: true },
          },
        ],
      })
    } else if (item?.applicationStatus === 'Rejected') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: { data: item, from: 'CHECKER_MYQUEUE', isApprovedByChecker: false, showApproveReject: true },
          },
        ],
      })
    } else {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: { data: item, from: 'CHECKER_QUEUE', isApprovedByChecker: false, showApproveReject: false },
          },
        ],
      })
    }
    setSideMenuRefresh(true)
  }
  console.log('currentPage', currentPage)

  const onItemChecked = (isChecked: boolean, index: any, rowData: any) => {
    const isEligibleToChecked =
      (rowData?.applicationStatus?.toLowerCase() === 'pending' ||
        rowData?.applicationStatus?.toLowerCase() === 'pending for approval') &&
      (rowData?.assignee?.toLowerCase() === 'na' || !rowData?.assignee)
    if (rowData && isEligibleToChecked) {
      updateSelectedRowIndex(currentPage - 1, index, rowData, isChecked)
      const rowsChecked = getRowsSelected(currentPage - 1)
      setShowClaim(rowsChecked.length > 0)
    }
  }

  const { width, height } = useWindowDimensions()
  const fetchDataOnChange = () => {
    console.count('===> fetchDataOnChange')
    setLoading(true)
    lazyGetGlobalCheckerList()
    setShowClaim(false)
  }

  const handleAllCheckedChange = (isChecked: boolean) => {
    console.log('===> handleAllCheckedChange', isChecked)
    updateAllRowsSelection(currentPage, isChecked)
    // const rowData = JSON.parse(JSON.stringify(listData[index]))
    // const rowsChecked = getRowsSelected(currentPage - 1)
    // setRowsChecked(rowsChecked)
    const list = getGlobalList()
    setListData(list)
    if (list && list?.length > 0 && list.filter((row) => row.isSelected).length > 0) {
      setShowClaim(true)
    } else {
      setShowClaim(false)
    }
  }

  const onFilterPress = () => {
    setFilterVisible(false)
    resetState()
  }

  const applyFilter = () => {
    fetchDataOnChange()
    setFilterVisible(false)
  }

  const navigateToMyQueue = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: 'checkerMyQueue' }],
    })
  }

  const handleCheckLater = () => {
    setShowAlertInfo(false)
    navigation.reset({
      index: 0,
      routes: [{ name: 'checkerGlobalQueue' }],
    })
  }

  const onClaimPress = () => {
    claimTaskApi(userName, getRowsSelected())
    setLoading(true)
  }

  const handleFilterVisibility = (visible: boolean) => {
    setFilterVisible(visible)
    if (visible) {
      saveState()
    }
  }

  const restoreFilterDefaults = () => {
    restoreFiltersToDefaults()
  }

  if (isLoading) {
    return <LoaderNew type={'large'} color={'PRIMARY'} />
  }
  return (
    <ModBox {...styles.container} show={!isLoading}>
      <Header
        fetchDataOnChange={fetchDataOnChange}
        filterVisible={filterVisible}
        setFilterVisible={handleFilterVisibility}
        filterApplied={
          selectedFilteredData?.applicationStatus?.length > 0 &&
          !selectedFilteredData?.applicationStatus?.includes('ALL')
        }
      />
      <ModBox padding={16} show={!filterVisible} minHeight={height <= 720 ? 600 : undefined}>
        <NewTable
          data={listData}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={checkerHeaderTitles}
          onRowClick={onPress}
          onCheckChange={onItemChecked}
          // rowsChecked={rowsChecked}
          getIsAllSelected={handleAllCheckedChange}
          freezeColumn={'check'}
          freezeColumnWidth={50}
        />
      </ModBox>
      <ModBox show={filterVisible}>
        <Filters
          onPress={onFilterPress}
          selectedFilteredData={selectedFilteredData}
          updateFilters={updateFilters}
          filterData={[filtersData]}
          checkSelected={checkSelected}
          apply={applyFilter}
          selectedValue={selectedFilteredData?.applicationStatus}
          mode={filterTypes?.applicationStatus}
          restoreDefaults={restoreFilterDefaults}
        />
      </ModBox>
      <ModBox show={showClaim}>
        <Footer setShowAlertInfo={setShowAlertInfo} onClaimPress={onClaimPress} />
      </ModBox>
      <ModalAlertView
        message="Selected items are added to 'My Queue'."
        show={showAlertInfo}
        showHeader={false}
        title={''}
        buttonTitle={'Go to my queue'}
        cancelTitle={"I'll Check Later"}
        onDismiss={() => setShowAlertInfo(false)}
        onPress={() => [navigateToMyQueue(), setShowAlertInfo(false)]}
        onCancel={() => handleCheckLater()}
        positiveButtonColor={'PRIMARY'}
        cancelButtonColor={'WHITE'}
        height={50}
      />
    </ModBox>
  )
}

export const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    minHeight: 720,
    overflow: 'auto',
  } as BoxProps,
  header: {
    flexDirection: 'row',
    p: 16,
    h: 100,
    w: '100%',
    marginBottom: 16,
  } as BoxProps,
  footer: {
    p: 12,
    direction: 'row',
    justify: 'flex-end',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
  } as BoxProps,
}
export default Checker
